/**
 * 收款管理
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInput, XSelect, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import model from '@/reducers/finance/provisionaltaxregister/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { TableActionType as ta } from '@/util/enum';
import RejectModal from '../modal/RejectModal';
import { DefaultListFeilds as df, Status, OperateType } from '../types';
import { message } from 'antd';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.Component {

    state = {
        agreementId: '',
        tel: '',
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
        selectedRowKeys: [],
        selectedRows: [],
        openModeParam: {},
        currentOpenMode: '',
        state: {},
    }

    componentDidMount() {
        this.props.getStateList({ enumName: 'ReviewTaxEnum' });
        this.props.setBreadcrumbPaths(this.props.match);
    }

    // 查询
    _searchHandle = (useCache) => {
        const { agreementId, tel, state, pageNum, pageSize } = this.state;
        this.searchCache = {
            taxNumber: agreementId,
            mobile: tel,
            status: state.code,

            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getTableSource(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => this._searchHandle('useCache'));
    }

    // 重置
    _resetHandle = () => {
        this.setState({ agreementId: '', tel: '', state: {}, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 关闭弹框
    _closeMode = (reload) => {
        this.setState({ currentOpenMode: '', openModeParam: {} });
        if (reload) {
            this._searchHandle();
            this.setState({ selectedRows: [], selectedRowKeys: [] });
        }
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        switch (type) {
            case ta.detail:
                this.props.history.push({ pathname: `/home/finance/provisionaltaxregister/detail/${key}` });
                break;
        }
    }

    // 生成报表
    _exportInfo = (type) => {
        const { agreementId, tel, state } = this.state;

        let exportTaxNumberList = this.state.selectedRowKeys;
        if (exportTaxNumberList.length === 0) {
            exportTaxNumberList = this.props.tableSource.dataList.filter(v => v.taxStatus === Status.NEW).map(v => v[df.id]);
        }

        if (exportTaxNumberList.length === 0) {
            message.warning('请选择一条记录');
            return;
        }

        let url = {
            info: '/?cmd=com.xqxc.api.pig.mis.biz.platform.TaxCommissionRecordMisService.exportTaxReport',
            material: '/?cmd=com.xqxc.api.pig.mis.biz.platform.TaxCommissionRecordMisService.exportTaxMaterialReport'
        }[type];

        http(url, {
            exportTaxNumberList,
            mobile: tel,
            status: state.code,
            taxNumber: agreementId,
        }, 'POST').then((res) => {
            if (res.errCode === 0) {
                if (res.result) {
                    message.success('生成成功');
                    window.location = res.result;
                } else {
                    message.error('导出文件不存在');
                }
            }
        });
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case ta.sure:
                return <RejectModal title='驳回原因' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    _batchResolve = () => {
        let rows = this.state.selectedRows;
        if (rows.length === 0) {
            message.warning('请选择需要“开通”的记录');
            return;
        }
        if (rows.some(v => v[df.state] !== Status.NEW)) {
            message.warn('只能选择“申请中”的记录');
            return;
        }

        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.TaxCommissionRecordMisService.batchHandlerTaxingApply', {
            operateType: OperateType.BASH_PASS,
            taxNumberArray: rows.map(v => v[df.id])
        }).then(res => {
            let msg = res.message;
            if (res.errCode === 0) {
                msg = '操作成功';
                this._searchHandle();
                this.setState({ selectedRows: [], selectedKeys: [] });
            }
            message.info(msg);
        }).catch((res = {}) => message.error(res.message));
    }

    _batchReject = () => {
        let rows = this.state.selectedRows;
        if (rows.length === 0) {
            message.warning('请选择需要“驳回”的记录');
            return;
        }
        if (rows.some(v => v[df.state] !== Status.NEW)) {
            message.warn('只能选择“申请中”的记录');
            return;
        }

        this.setState({ currentOpenMode: ta.sure, openModeParam: { rows: rows.map(v => v[df.id]) } });
    }

    // 表格复选输入
    _rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            this.setState({ selectedRowKeys, selectedRows });
        },
    };

    render() {
        const { agreementId, tel, state } = this.state;
        let { curTabID, tableSource, stateList } = this.props;
        this._rowSelection.selectedRowKeys = this.state.selectedRowKeys;

        return (
            <KeepAlive id={curTabID} render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 200 }}
                                label='协议编号'
                                placeholder='请输入'
                                value={agreementId}
                                bindThis={this}
                                bindName='agreementId'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 200 }}
                                label='手机号码'
                                placeholder='请输入'
                                value={tel}
                                bindThis={this}
                                bindName='tel'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '150px' }}
                                label='状态'
                                placeholder='请选择'
                                renderData={stateList}
                                dataIndex='value'
                                keyIndex='code'
                                value={state.value}
                                bindThis={this}
                                bindName='state'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.row2}>
                        <XOKButton
                            style={{ width: 100, marginRight: 10 }}
                            label='导出信息'
                            onClick={() => this._exportInfo('info')}
                        />
                        <XOKButton
                            style={{ width: 100, marginRight: 10 }}
                            label='导出材料'
                            onClick={() => this._exportInfo('material')}
                        />
                        <XOKButton
                            style={{ width: 100, marginRight: 10 }}
                            label='批量开通'
                            onClick={this._batchResolve}
                        />
                        <XOKButton
                            style={{ width: 100, marginRight: 10 }}
                            label='批量驳回'
                            onClick={this._batchReject}
                        />
                    </div>
                    <div style={{ marginTop: 5 }}>说明：只导出状态为申请中的会员文件及材料</div>
                    <TableList
                        renderData={tableSource}
                        rowSelection={this._rowSelection}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,
    setBreadcrumbPaths: PropTypes.func,

    getTableSource: PropTypes.func,
    tableSource: PropTypes.object,

    getStateList: PropTypes.func,
    stateList: PropTypes.array
};
const mapStateToProps = (state) => ({
    stateList: state.provisionaltaxregister.stateList,
    tableSource: state.provisionaltaxregister.tableSource,
});

export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);